var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "list-search" }, [
    _c("form", [
      _c(
        "div",
        { staticClass: "row row-clear-sm-6-md-4" },
        [
          _c("div", { staticClass: "col-sm-6 col-md-4" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { staticClass: "sr-only" }, [_vm._v("Keywords")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.stateKeywords,
                    expression: "stateKeywords",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  name: "keywords",
                  type: "text",
                  placeholder: "Keywords",
                },
                domProps: { value: _vm.stateKeywords },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.stateKeywords = $event.target.value
                  },
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-6 col-md-4" }, [
            _vm.$userIsAdmin &&
            _vm.showRegionFilter &&
            _vm.regionOptions.length > 1
              ? _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { staticClass: "sr-only" }, [_vm._v("Region")]),
                    _vm._v(" "),
                    _c("selectize", {
                      ref: "regions",
                      staticClass: "selectize selectize-multiple",
                      attrs: {
                        multiple: "",
                        name: "region",
                        placeholder: "Region",
                        options: _vm.regionOptions,
                      },
                      model: {
                        value: _vm.stateRegions,
                        callback: function ($$v) {
                          _vm.stateRegions = $$v
                        },
                        expression: "stateRegions",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm._t("additional-filters"),
          _vm._v(" "),
          _c("div", { staticClass: "text-right spacer-r-2" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _vm._t("button"),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
              ],
              2
            ),
          ]),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }